<section class="text-gray-600 body-font">
  <div class="container mx-auto flex px-5 py-24 items-center justify-center flex-col">
    <img class="lg:w-2/6 md:w-3/6 w-5/6 mb-10 object-cover object-center rounded" [alt]="'WhatsAuto' | appData" [src]="'logo.svg' | assetsSource">
    <div class="text-center lg:w-2/3 w-full">
      <h1 class="title-font sm:text-3xl text-2xl mb-4 font-medium text-gray-900">A página que você procura não foi encontrada</h1>
      <div class="flex justify-center">
        <a routerLink="/" class="btn btn-primary">VOLTAR PARA A HOME</a>
      </div>
    </div>
  </div>
</section>
